import React, { useEffect, useState } from "react";
import axios, { decryptData } from "../Axiosinstance";
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Loader from "../Loader";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
// CHANGE import
import { baseURLdyte } from "../common";
import Button from "@mui/material/Button";

const Recoedings = () => {
  const { batchId } = useParams();
  // const { batchId } = useParams();
  const batchId1 = decryptData(decodeURIComponent(batchId));
  // const intakeId1 = decryptData(decodeURIComponent(intakeId))
  const [batchDetails, setBatchDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [matchingSessions, setMatchingSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  useEffect(() => {
    const fetchBatchDetails = async () => {
      try {
        const response = await axios.get(`batch/${batchId1}`);
        setBatchDetails(response.data);
      } catch (error) {
        console.error("Error fetching batch details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBatchDetails();
  }, [batchId1]);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        // fetchSessions — REPLACE
        const sessionsResponse = await axios.get(`${baseURLdyte}/recordings`);
        const sessions = sessionsResponse.data?.result;

        if (batchDetails && sessions) {
          const url = batchDetails.onlineclasslink;
          const match = url.match(/id=([a-f\d-]+)/i);

          if (match && match[1]) {
            const meetingId = match[1];

            const matchingSessions = sessions.filter(
              (session) => session.meeting_id === meetingId,
            );

            setMatchingSessions(matchingSessions);
            console.log(matchingSessions);
          } else {
            console.warn("Meeting ID not found in onlineclasslink");
          }
        }
      } catch (error) {
        console.error("Error fetching sessions:", error);
      } finally {
        setTableLoading(false);
      }
    };

    fetchSessions();
  }, [batchDetails]);

  // const formatDate = (dateString) => {
  //   const options = {
  //     year: 'numeric',
  //     month: 'long',
  //     day: 'numeric',
  //     hour: 'numeric',
  //     minute: 'numeric',
  //     second: 'numeric',
  //   };
  //   return new Date(dateString).toLocaleDateString(undefined, options);
  // };

  function formatDate(dateInput) {
    const date = new Date(dateInput);

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date input");
    }

    const pad = (num) => String(num).padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  const handleRowClick = (session) => {
    setSelectedSession(session);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedSession(null);
    setShowModal(false);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Set the number of sessions per page

  // Calculate the indexes for the current page
  const indexOfLastSession = (page + 1) * rowsPerPage;
  const indexOfFirstSession = indexOfLastSession - rowsPerPage;
  const currentSessions = matchingSessions.slice(
    indexOfFirstSession,
    indexOfLastSession,
  );

  // Function to handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Function to handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="container-fluid" style={{ maxWidth: "1400px" }}>
      <br />
      {loading && <Loader />}
      {!loading && (
        <TableContainer>
          <Table striped bordered hover responsive>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>S.no</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Meeting Name
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Recording Duration
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Starting At
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Ending At</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableLoading ? (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: "center" }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : matchingSessions.length > 0 ? (
                matchingSessions.map((session, index) => (
                  <TableRow
                    key={session.id}
                    onClick={() => handleRowClick(session)}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{session.meeting?.title || "N/A"}</TableCell>
                    <TableCell>
                      {session.recording_duration
                        ? `${session.recording_duration} seconds`
                        : "N/A"}
                    </TableCell>
                    <TableCell>
                      {session.started_time
                        ? formatDate(session.started_time)
                        : "N/A"}
                    </TableCell>
                    <TableCell>
                      {session.stopped_time
                        ? formatDate(session.stopped_time)
                        : "N/A"}
                    </TableCell>
                    <TableCell>
                      <Button variant="contained" color="primary">
                        View Video
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    style={{ textAlign: "center", color: "gray" }}
                  >
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {/* Modal */}
          <Modal show={showModal} onHide={handleCloseModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Recording Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedSession && (
                <div>
                  <h5 className="mb-3">
                    Meeting Name: {selectedSession.meeting.title}
                  </h5>
                  <p>
                    Recording Duration: {selectedSession.recording_duration}{" "}
                    seconds
                  </p>
                  <p>Started At: {formatDate(selectedSession.started_time)}</p>
                  <p>Ended At: {formatDate(selectedSession.stopped_time)}</p>

                  <div className="embed-responsive embed-responsive-16by9 mb-3">
                    <video
                      className="embed-responsive-item"
                      controls
                      width="100%"
                    >
                      <source
                        src={selectedSession.download_url}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <p>
                    <a
                      href={selectedSession.download_url}
                      download={selectedSession.output_file_name}
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#007bff",
                        borderColor: "#007bff",
                        color: "white",
                      }}
                    >
                      Download
                    </a>
                  </p>
                </div>
              )}
            </Modal.Body>
          </Modal>

          <TablePagination
            component="div"
            count={matchingSessions.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      )}
    </div>
  );
};

export default Recoedings;
